export * from "./test.service";



// WEBPACK FOOTER //
// ./src/app/shared/services/test/index.ts